import { Button, required, useNotify, useRefresh } from "react-admin";
import DoneAllIcon from "@mui/icons-material/DoneAll";
import { Grid } from "@mui/material";

import { erasmusRequests } from "api/erasmusApi";
import CustomDateInput from "server/components/Fields/CustomDateInput";
import FormModal from "server/components/Modals/FormModal";
import dataProvider from "server/dataProvider";
import { toDateOnly } from "utils/helpers";

const CoordinatorFinishDialog = ({ id }) => {
  const notify = useNotify();
  const refresh = useRefresh();

  const defaultValues = { finishDate: toDateOnly(new Date().toISOString()) };

  const handleFinish = async data => {
    await dataProvider.customRequest(
      erasmusRequests.finishIncomingInternshipStudent(id),
      { finishDate: data.finishDate },
      "PUT",
    );
    notify("Стажът е приключен успешно", { type: "success" });
    refresh();
  };

  return (
    <FormModal
      titleContent="Приключване на стаж"
      dialogSize="sm"
      defaultValues={defaultValues}
      onConfirm={handleFinish}
      triggerButton={
        <Button
          label="Приключи"
          variant="contained"
          color="success"
          startIcon={<DoneAllIcon />}
        />
      }
    >
      <Grid
        container
        spacing={2}
      >
        <Grid
          item
          xs={12}
        >
          <CustomDateInput
            source="finishDate"
            label="Дата на приключване"
            noTime
            required={true}
            validate={required()}
          />
        </Grid>
      </Grid>
    </FormModal>
  );
};

export default CoordinatorFinishDialog;
